import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import configureStore from 'store/configureStore';

import { loadableReady } from '@loadable/component';

import App from './App';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { wrapHistory } from 'oaf-react-router';

import { UserAgentProvider } from 'hooks/useUAParser';
import { useSSR } from 'react-i18next';
import 'utils/i18n';
import env from 'utils/env';

import log from 'loglevel';
import { RefererUrlProvider } from 'hooks/useReferrerQueryParameters';

// Polyfill for focus-visible needs to be imported
import 'focus-visible';

if (process.env.NODE_ENV === 'development') {
  log.setLevel(log.levels.DEBUG);
}

const history = createBrowserHistory({
  basename: env.BASENAME,
});

const settings = {
  renderTimeout: 300,
};
wrapHistory(history, settings);

const ClientApp: React.FC = () => {
  useSSR(window.__INITIAL_I18N_STORE__, window.__INITIAL_LANGUAGE__);
  const store = configureStore();
  if (window.Cypress) {
    window.store = store;
  }

  return (
    <Provider store={store}>
      <UserAgentProvider userAgentString={window.navigator.userAgent}>
        <RefererUrlProvider refererUrl={document.referrer}>
          <Router history={history}>
            <App />
          </Router>
        </RefererUrlProvider>
      </UserAgentProvider>
    </Provider>
  );
};

loadableReady(() => {
  ReactDOM.hydrate(<ClientApp />, document.getElementById('root'));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
